"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMountEffect = void 0;
const react_1 = require("react");
/**
 * Run effect only when component is first mounted.
 *
 * @param effect Effector to run on mount
 */
function useMountEffect(effect) {
    (0, react_1.useEffect)(() => {
        effect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
exports.useMountEffect = useMountEffect;
